import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowLeft,
  faShoppingCart,
  faTags,
  faInfoCircle,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../AuthContext';
import ManagePlans from './ManagePlans';

const EcommercePricing = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
            <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-600 text-2xl" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Access Denied</h2>
          <p className="text-gray-600 mb-6">Admin access required to view this page.</p>
          <button
            onClick={() => navigate('/dashboard/admin')}
            className="px-4 py-2 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors"
          >
            Back to Admin Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex items-center">
              <button
                onClick={() => navigate('/dashboard/admin')}
                className="mr-4 w-10 h-10 flex items-center justify-center rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <h1 className="text-2xl font-bold text-gray-900">E-commerce Plans</h1>
            </div>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-6">
          <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-2xl p-6 text-white shadow-lg">
            <div className="flex items-center">
              <div className="w-12 h-12 rounded-xl bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center mr-4">
                <FontAwesomeIcon icon={faShoppingCart} className="text-white text-xl" />
              </div>
              <div>
                <h2 className="text-xl font-bold">E-commerce Pricing Plans</h2>
                <p className="text-red-100">Manage and configure pricing plans for e-commerce deliveries</p>
              </div>
            </div>
          </div>
        </div>

        {/* Info Card */}
        <div className="bg-blue-50 rounded-2xl p-6 border border-blue-200 mb-6">
          <div className="flex items-start">
            <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center mr-3 flex-shrink-0">
              <FontAwesomeIcon icon={faInfoCircle} className="text-blue-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-blue-800">Plan Management</p>
              <p className="text-xs text-blue-700 mt-1">Create, edit, and manage pricing plans for e-commerce deliveries. Changes will affect all new e-commerce shipment calculations.</p>
            </div>
          </div>
        </div>

        {/* Render plan management UI */}
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
          <div className="p-6 border-b border-gray-100">
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-xl bg-red-100 flex items-center justify-center mr-3">
                <FontAwesomeIcon icon={faTags} className="text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">Manage Plans</h3>
            </div>
          </div>
          <div className="p-6">
            <ManagePlans />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EcommercePricing;